<!-- @format -->

<template>
	<div>
		<el-input v-model="filterValue" size="small" style="margin-bottom: 3px" placeholder="请输入关键字查询" />
		<pc-collapse v-if="checkGroupList[0]?.children" v-model="activeCollapse">
			<pc-collapse-item v-for="item in checkGroupList" :key="item.code" :title="item.label" :name="item.code">
				<el-checkbox-group v-model="checkList" class="checkbox-group-list" @change="onChange">
					<el-checkbox
						v-for="itm in item.children"
						:key="itm.code"
						:label="itm.code"
						class="checkbox-group-item"
						size="large"
					>
						<slot :item="itm"> {{ itm.label }} </slot>
					</el-checkbox>
				</el-checkbox-group>
			</pc-collapse-item>
		</pc-collapse>
		<el-checkbox-group v-else v-model="checkList" class="checkbox-group-list" @change="onChange">
			<el-checkbox
				v-for="item in checkGroupList"
				:key="item.code"
				:label="item.code"
				class="checkbox-group-item"
				size="large"
			>
				<slot :item="item"> {{ item.label }} </slot>
			</el-checkbox>
		</el-checkbox-group>
	</div>
</template>

<script setup lang="ts">
	import type { CheckGroupList } from './types';
	import { PcCollapse, PcCollapseItem } from '@/components';

	interface Props {
		list?: CheckGroupList; // checkboxList
		modelValue: string[]; // 绑定选中的值
	}

	const props = withDefaults(defineProps<Props>(), {
		list: () => [],
	});

	const emit = defineEmits(['update:modelValue', 'change']);

	const filterValue = ref<string>('');

	const activeCollapse = ref<string[]>(props.list.map((i) => i.code));

	const checkList = computed({
		get() {
			return props.modelValue;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	const onChange = (e) => {
		//console.log(e);

		emit('change', e);
	};

	const filterList = (list: CheckGroupList): CheckGroupList =>
		list?.filter((itm) => itm.label.includes(filterValue.value)) || [];

	// 通过过滤条件后的数据
	const checkGroupList = computed(() => {
		return props.list[0]?.children
			? props.list.reduce((arr, item) => {
					const children = filterList(item.children as CheckGroupList);
					if (children.length) {
						return [...arr, { ...item, children }];
					} else {
						return arr;
					}
			  }, [])
			: filterList(props.list);
	});

	const flatList = computed(() =>
		props.list.reduce((arr, itm) => (itm.children ? [...arr, ...itm.children] : [...arr, itm]), []),
	);

	const getItem = (list: CheckGroupList, code: string) =>
		list
			.reduce((arr, itm) => (itm.children ? [...arr, ...itm.children] : [...arr, itm]), [])
			.find((item) => item.code === code);

	const checkItemList = computed(
		(): CheckGroupList =>
			checkList.value.reduce((arr: CheckGroupList, itm) => {
				const item = getItem(flatList.value, itm);
				item && arr.push(item);
				return arr;
			}, []),
	);

	defineExpose({ checkItemList });
</script>

<style scoped lang="scss">
	.checkbox-group-list {
		display: flex;
		flex-wrap: wrap;
		width: 100%;

		.checkbox-group-item {
			flex: 50%;
			text-align: center;
			margin: 0;
		}
	}
</style>
